export default __webpack_public_path__ + "static/media/nailspink.5391eaee.jpg";